"use client";

import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import React from "react";

interface MobileSubMenuProps {
  title: string;
  children: React.ReactNode;
}

export const MobileSubMenu = ({ title, children }: MobileSubMenuProps) => {
  return (
    <AccordionItem value={`item-${title}`} className="border-none">
      <AccordionTrigger
        direction="right"
        className="appearance-none bg-transparent border-none w-full justify-between p-xl text-sm-semibold text-white hover:text-white [&_svg]:text-current"
      >
        {title}
      </AccordionTrigger>
      <AccordionContent className="mb-4xl">
        <div className="flex flex-col bg-white rounded-sm shadow-xs overflow-hidden p-xl space-y-4xl">
          {children}
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};
